module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_students-sp-2aa4507e69b2455eb0d48852f6747082.png";